import React, { useMemo } from 'react';

import Typography from 'components/uiLibrary/Typography';

import { TAG_TYPES } from 'constants/index';

import { getProductionTags } from 'utils/productions';

import { useTranslation } from 'src/i18n';

import classes from './ProductionOtherTags.module.scss';

const ProductionOtherTags = ({ production }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const tags = useMemo(
    () => getProductionTags(production, [TAG_TYPES.PRODUCTION, TAG_TYPES.FESTIVAL, TAG_TYPES.DATE], true),
    [],
  );

  if (tags?.length === 0) {
    return null;
  }

  return (
    <div className={classes.otherTags}>
      {tags?.map((tag, index) => (
        <Typography className={classes.otherTags__tagItem} size={10} key={index} color="secondary">
          {t(tag?.label)}
        </Typography>
      ))}
    </div>
  );
};

export default ProductionOtherTags;
